import { ChevronLeft } from 'lucide-react';
import { memo, type ReactNode } from 'react';

import { Button } from '../button/button';
import { IconButton } from '../button/icon-button';

export interface StackProps {
  onBack?: () => void;
  title?: ReactNode;
  children: ReactNode;
  onRight?: () => void;
  rightButtonTitle?: ReactNode;
}

export const Stack = memo(
  ({ children, title, onBack, onRight, rightButtonTitle }: StackProps) => {
    const hasRightAction = !!(rightButtonTitle && onRight);

    return (
      <div className='flex size-full grid-cols-1 flex-col bg-chat-background text-chat-foreground'>
        {(title || onBack) && (
          <div className='flex flex-row items-center justify-between border-b border-chat-border px-5 py-3'>
            <div className='grid w-full grid-cols-7 items-center justify-center'>
              {onBack && (
                <IconButton onClick={onBack} data-testid='get-back-button'>
                  <ChevronLeft />
                </IconButton>
              )}
              {title && (
                <div className='col-span-5 text-center text-xl font-semibold'>
                  {title}
                </div>
              )}
              {hasRightAction && (
                <Button onClick={onRight}>{rightButtonTitle}</Button>
              )}
            </div>
          </div>
        )}
        <div className='h-fit overflow-y-auto p-5'>{children}</div>
      </div>
    );
  },
);
